// extracted by mini-css-extract-plugin
module.exports = {"container":"MapSidebarCanary_container__PKoCN"};